import { useSearchParams } from "react-router";

interface UseStepNavigationOptions {
  /** Array of step identifiers for URL navigation */
  stepIds: string[];
  /** The URL parameter name to use (default: "step") */
  paramName?: string;
  /** The default step index when no parameter is present (default: 0) */
  defaultStep?: number;
  /** Whether to use replace or push for navigation (default: true) */
  replace?: boolean;
}

export function useStepNavigation(options: UseStepNavigationOptions) {
  const {
    stepIds,
    paramName = "step",
    defaultStep = 0,
    replace = true,
  } = options;
  const [searchParams, setSearchParams] = useSearchParams();

  const currentStepParam = searchParams.get(paramName);

  const stepIndex = currentStepParam ? stepIds.indexOf(currentStepParam) : -1;
  const currentStep = stepIndex >= 0 ? stepIndex : defaultStep;

  const navigateToStep = (stepIndex: number) => {
    const stepId = stepIds[stepIndex];
    if (stepId) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set(paramName, stepId);
      setSearchParams(newParams, { replace });
    }
  };

  return {
    currentStep,
    navigateToStep,
  };
}
